export const siteConfig = {
  name: '小辣椒影院',
  tagline: '高清电影免费在线观看不卡顿',
  description: '小辣椒影院提供高清电影免费在线观看，画质清晰不卡顿，免费影视网站汇聚高清电视剧免费全集，秒开流畅播放，最新热门电影电视剧随时在线看。',
  keywords: '小辣椒影院,高清电影免费,在线观看不卡顿,免费影视网站,高清电视剧免费,免费在线影院,高清电影在线,不缓冲影视,免费看剧,最新电视剧在线',
  url: 'https://wangmeiqi.cn',
  logo: '小辣椒影院',
  founded: '2020',
  email: 'contact@xiaolajiao.com',
  phone: '400-888-6666',
  address: '北京市朝阳区望京科技园A座',
  socialMedia: {
    weibo: 'https://weibo.com/xiaolajiao',
    wechat: '小辣椒影院',
  },
};

export const aboutContent = {
  brandIntro: `
小辣椒影院成立于2020年，是国内领先的免费高清影视在线观看平台。我们致力于为广大影视爱好者提供最优质、最流畅的在线观影体验。

自成立以来，小辣椒影院始终坚持"免费、高清、流畅"的服务理念，不断优化播放技术，提升内容质量。我们的片库涵盖电影、电视剧、综艺、动漫、纪录片等多种类型，满足不同用户的观影需求。

小辣椒影院拥有专业的内容运营团队，每日更新最新影视资源，确保用户第一时间观看到最新最热的影视内容。我们的技术团队持续优化播放体验，让每一位用户都能享受到秒开流畅的高清观影体验。

"小辣椒"寓意着热情、活力与坚持——正如一颗小小的辣椒能够带来强烈的味觉体验，我们希望用最优质的服务，为每一位用户带来最极致的观影享受。
  `,
  reputation: [
    {
      title: '高清画质',
      description: '所有影视资源均提供1080P以上高清画质，部分热门内容支持4K超清播放，让您在家也能享受影院级观影体验。',
      icon: 'ri-4k-line',
    },
    {
      title: '流畅播放',
      description: '采用先进的CDN加速技术和智能码率调节算法，确保在不同网络环境下都能实现秒开流畅的播放体验，告别卡顿和缓冲。',
      icon: 'ri-speed-up-line',
    },
    {
      title: '海量片库',
      description: '收录超过10万部影视作品，涵盖国内外热门电影、电视剧、综艺、动漫、纪录片等，每日更新，总有你想看的。',
      icon: 'ri-database-2-line',
    },
    {
      title: '完全免费',
      description: '坚持免费服务理念，所有内容均可免费在线观看，无需会员、无需付费，让每个人都能轻松享受精彩影视内容。',
      icon: 'ri-vip-crown-line',
    },
    {
      title: '多端支持',
      description: '完美支持PC端、手机端、平板端，随时随地同步观看记录，电脑没看完手机接着看，无缝衔接。',
      icon: 'ri-device-line',
    },
    {
      title: '用户至上',
      description: '24小时客服在线，用心倾听每一位用户的反馈和建议，持续优化产品体验，做用户最信赖的影视平台。',
      icon: 'ri-customer-service-2-line',
    },
  ],
  stats: [
    { label: '影视作品', value: '100,000+' },
    { label: '日活用户', value: '500万+' },
    { label: '累计播放', value: '50亿+' },
    { label: '用户好评率', value: '98.5%' },
  ],
};